import * as yup from "yup";
import { useMutation } from "@tanstack/react-query";
import { HTTP_ENDPOINTS } from "../../consts/api";
import { http } from "../../services/HttpService";
import { removeNullishFromShape } from "../../utilities/general";

const requestSchema = yup.object({
  term: yup.string().nullable(),
});

const responseSchema = yup.object({
  file: yup.string().required(),
});

const composeResponse = (res) => {
  return res.data?.data;
};

export const useExportPricingVariationMutation = (options = {}) => {
  return useMutation(async (payload) => {
    const req = requestSchema.validateSync(payload, {
      strict: true,
    });

    const res = await http.get(HTTP_ENDPOINTS.exportPricingVariation(), {
      params: removeNullishFromShape({
        term: req.term,
      }),
    });

    return responseSchema.validateSync(composeResponse(res), { strict: true });
  }, options);
};
